module.exports = __webpack_public_path__ + "img/About_pic2.83145bbe.png";